module.exports = __webpack_public_path__ + "static/media/plus.c0fd793c.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/plus.svg
// module id = ./src/assets/icons/plus.svg
// module chunks = 0